            <!-- Navbar -->
            <div class="content">
                <div class="content">
                <div class="container-fluid">
                <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 common_title">
               <h2>ANIMAL MANAGEMENT - STOCK</h2>
                 <p>List of animal</p>
                  <a (click)=backtomastermodule() class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
                   Back
                 </a>
               </div>
              </div>
               <div class="row">
                 <div class="col-lg-4 col-md-6 col-sm-6" *ngFor='let specieslist of Getallspecies' >
                   <a data-toggle="modal"   ><div class="card card-stats" style="cursor:pointer">
                    <div class="card-header card-header-warning card-header-icon">
                        <p class="card-category">{{specieslist.name}}</p>
                        <p class="card-category count">{{specieslist.value}}</p>
                       </div>
                       <div class="card-icon">
                        <img alt="" src="assets/images/Cow.png" />
                       </div>
                     <!--<div class="card-footer">
                       <div class="stats">
                         <i class="material-icons text-danger">warning</i>
                         <a href="#pablo">Get More Space...</a>
                       </div>
                     </div>-->
                   </div></a>
                 </div>
                 <div class="col-lg-4 col-md-6 col-sm-6">
                        <a (click)="listview()" ><div class="card card-stats"  style="cursor:pointer">
                        <div class="card-header card-header-warning card-header-icon">
                        <p class="card-category">ADD</p><br>
                        <p class="card-category">ANIMALS</p>
                       </div>
                       <div class="card-icon">
                        <img alt="" src="assets/images/pluse.png" />
                       </div>
                       <!--<div class="card-footer">
                       <div class="stats">
                         <i class="material-icons text-danger">warning</i>
                         <a href="#pablo">Get More Space...</a>
                       </div>
                     </div>-->
                   </div></a>
                 </div>
               </div>
             </div>
           </div>
         </div>    

              <!--<footer class="footer">
                <div class="container-fluid">
                  <nav class="float-left">
                    <ul>
                      <li>
                        <a href="#">
                          Creative Tim
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          About Us
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          Blog
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          Licenses
                        </a>
                      </li>
                    </ul>
                  </nav>
                  <div class="copyright float-right">
                    &copy;
                    <script>
                      document.write(new Date().getFullYear())
                    </script>, All Right reserved by
                    <a href="#" target="_blank">Redantmedia</a> 
                  </div>
                </div>
              </footer>-->
        
        <!-------------END CARD-------------->
        
          <!-- The Modal -->
          <div class="modal" id="myModal">
            <div class="modal-dialog">
              <div class="modal-content">
              
                <!-- Modal Header -->
                <div class="modal-header">
                  <h3 class="modal-title">ANIMAL MANAGEMENT - STOCK</h3>
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>         
                <!-- Modal body -->
                <div class="modal-body">
                  <h3><a data-dismiss="modal" style="cursor:pointer"  >Box View</a></h3>
                </div>
                <div class="modal-body">
                  <h3><a data-dismiss="modal" style="cursor:pointer" (click)="listview() ">List View</a></h3>
                  </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>
                
              </div>
            </div>
          </div>
          
        